// These are the hardcoded risk levels and their corresponding percentages.
export const riskLevels = { 
    1: {
        level: 1, 
        bonds: 80, 
        largeCap: 20, 
        midCap: 0, 
        foreign: 0,
        smallCap: 0
    },
    2: {
        level: 2,
        bonds: 70,
        largeCap: 15,
        midCap: 15,
        foreign: 0,
        smallCap: 0
    },
    3: {
        level: 3,
        bonds: 60,
        largeCap: 15,
        midCap: 15,
        foreign: 10,
        smallCap: 0
    },
    4: {
        level: 4,
        bonds: 50,
        largeCap: 20,
        midCap: 20,
        foreign: 10,
        smallCap: 0
    },
    5: {
        level: 5,
        bonds: 40,
        largeCap: 20,
        midCap: 20,
        foreign: 20,
        smallCap: 0
    },
    6: {
        level: 6,
        bonds: 35,
        largeCap: 25,
        midCap: 5,
        foreign: 30,
        smallCap: 5
    },
    7: {
        level: 7,
        bonds: 20,
        largeCap: 25,
        midCap: 25,
        foreign: 25,
        smallCap: 5
    },
    8: {
        level: 8,
        bonds: 10,
        largeCap: 20,
        midCap: 40,
        foreign: 20,
        smallCap: 10
    },
    9: {
        level: 9,
        bonds: 5,
        largeCap: 15,
        midCap: 40,
        foreign: 25,
        smallCap: 15
    },
    10: {
        level: 10,
        bonds: 0,
        largeCap: 5,
        midCap: 25,
        foreign: 30,
        smallCap: 40
    }
};